import AmexPlatinumNights, { ComponentAmexPlatinumNightsUnderTest } from './AmexPlatinumNights';

export default AmexPlatinumNights;

export {
  ComponentAmexPlatinumNightsUnderTest,
};
